class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('load', () => {
      this.initAllLogic();
    });

  }

  initAllLogic() {
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;
    this.previousSkin = false;

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    if (this.input.id == "Search-In-Template") {
      this.addEventListener('focusout', this.onFocusOut.bind(this));
    }
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    // remove focus from input when scrolling results
    this.predictiveSearchResults.addEventListener('scroll', () => {
      this.input.blur();
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const suggestions = document.querySelectorAll(".predictive-search-suggestions");
    suggestions.forEach(suggestion => {
      suggestion.classList.add('hidden-suggestions')
    })
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      suggestions.forEach(suggestion => {
        suggestion.classList.remove('hidden-suggestions')
      })
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }

    // display submit arrow after user begins typing
    const searchArrow = this.querySelector('.predictive-search__item--term');
    searchArrow.classList.remove('show');
    setTimeout(() => {
      if (this.getQuery().trim().length) {
        if (!searchArrow.classList.contains('show')) {
          searchArrow.classList.add('show');
        }
      } else {
        searchArrow.classList.remove('show');
      }
    }, 0);
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }
    let searchUrl = `/search?q=${encodeURIComponent(searchTerm)}&type=product&view=fetch`
    fetch(searchUrl)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        // document.querySelectorAll(".predictive-search-suggestions").forEach(el => {
        //   el.classList.add("hidden")
        // })
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  // filterSearchResultsBySkin() {
  //   let activeSkin = localStorage.getItem('activeSkin');
  //   /* If random shades functionality is active and skin is set to default */
  //   if (useRandomShades && activeSkin === 'default') {
  //     const productGroups = document.querySelectorAll('.predictive-search-image[data-product]');
  //     const productsOnPage = {}; const productsNotOnPage = [];
  //     for (const product of productGroups) {
  //       const productId = product.getAttribute('data-product');
  //       const productElement = document.querySelector('[data-imagesGroupForSkin][data-product="' + productId + '"]');
  //       /* If product exists on the page use same skin */
  //       if (productElement) {
  //         const localstorageKey = productId + '_skin';
  //         const skin = localStorage.getItem(localstorageKey);
  //         if (skin) {
  //           productsOnPage[productId] = skin;
  //         }
  //       } else {
  //         productsNotOnPage.push(product);
  //       }
  //     }

  //     let productTypes = productsOnPage;
  //     if (productsNotOnPage.length) {
  //       /* Generate product types for products which are not on page */
  //       const productsNotOnPageTypes = window.getRandomSkinTypes(productsNotOnPage);
  //       productTypes = Object.assign(productsOnPage, productsNotOnPageTypes);
  //     }
  //     productGroups.forEach((group, i) => {
  //       // Get the product cards for this group and the group's product ID
  //       const images = group.querySelectorAll('.skinPickerImage');
  //       const productId = group.getAttribute('data-product');
  //       // Get the skin type for this group and save it to local storage
  //       const localstorageKey = productId + '_skin';
  //       let groupSkin = productTypes[productId];
  //       let groupSkinArray = [];
  //       const previousGroupSkin = localStorage.getItem(localstorageKey);

  //       if (previousGroupSkin) {
  //         groupSkinArray = previousGroupSkin.split('|');
  //       }
  //       // Check if previous skin from skinSelector is set and if previous skin for product is set
  //       if (this.previousSkin && previousGroupSkin) {
  //         groupSkin = groupSkinArray.slice(-1);
  //       } else {
  //         if (groupSkinArray.length > 1) {
  //           groupSkinArray.shift();
  //         }
  //         groupSkinArray.push(groupSkin);
  //       }
  //       if (groupSkin) {
  //         localStorage.setItem(localstorageKey, groupSkinArray.join('|'));
  //         // Update the active state of the skin picker images based on the selected skin type for this group
  //         // Loop through each element and check its data-imageSkin attribute
  //         images.forEach((image) => {
  //           const skin = image.getAttribute('data-imageSkin');
  //           // If the attribute includes the activeSkin, add class "thumbnail-list-active"
  //           if (skin.includes(groupSkin)) {
  //             image.classList.add('--is-active');
  //           } else {
  //             // Otherwise, remove class "thumbnail-list-active"
  //             image.classList.remove('--is-active');
  //           }
  //         });
  //       }
  //     });
  //     this.previousSkin = true;
  //     return false;
  //   }

  //   if (activeSkin) {
  //     const images = document.querySelectorAll('#predictive-search-results-list .skinPickerImage');

  //     // Loop through each element and check its data-imageSkin attribute
  //     images.forEach((image) => {
  //       const skin = image.getAttribute('data-imageSkin');
  //       // If the attribute includes the activeSkin, add class "thumbnail-list-active"
  //       if (skin.includes(activeSkin)) {
  //         image.classList.add('--is-active');
  //       } else {
  //         // Otherwise, remove class "thumbnail-list-active"
  //         image.classList.remove('--is-active');
  //       }
  //     });
  //     return false;
  //   }
  // }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  
    // this.filterSearchResultsBySkin();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    setTimeout(() => {
      this.querySelector('#predictive-search-results-list').classList.add('--is-active');
    }, 25);
    // this.filterSearchResultsBySkin();

  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');

    this.input.setAttribute('aria-expanded', false);
    this.predictiveSearchResults.removeAttribute('style');

    setTimeout(() => {
      this.removeAttribute('open');
      this.isOpen = false;
    }, 350);

    this.querySelector('#predictive-search-results-list').classList.remove('--is-active');
  }
}

customElements.define('predictive-search', PredictiveSearch);
